/*
  CUSTOM-2O3: Alpine UI-state layer for 2o3 (Concept theme)
  See docs/FRONTEND-STACK.md. Rules of the road:
    - Alpine manages STATE for OUR custom_2o3_* wrappers only.
    - NEVER put x-data on a Concept custom element or its internals (breaks hydration).
    - Bridge to the theme via Concept's document events (cart:updated -> {cart}, variant:change, ...).
    - Pair with GSAP for motion: Alpine holds state, GSAP animates the transition.
*/
document.addEventListener('alpine:init', function () {
  // Register Alpine.data components here as we build them. Example:
  // Alpine.data('twoO3Disclosure', function () {
  //   return {
  //     open: false,
  //     toggle: function () { this.open = !this.open; }
  //   };
  // });
});
